























































import Vue from 'vue';
import FilterTagsRow from '@common/filter-tag/filter-tags-row.vue';
import {UserActivityCategoryEnum} from '@mobi-components/global-solution';
import SectionHeader from '../section-header/section-header.vue';

// @ts-ignore
import StayIcon from '@components/svg/stay.svg';
// @ts-ignore
import ExpIcon from '@components/svg/marker2.svg';
// @ts-ignore
import DiningIcon from '@components/svg/dining.svg';

export default Vue.extend({
  name: 'PreferencesBox',
  components: {
    FilterTagsRow,
    SectionHeader,
  },
  props: {
    filterTags: Array,
  },
  data: () => ({
    UserActivityCategoryEnum,
    ExpIcon,
    StayIcon,
    DiningIcon,
    images: [
      'https://media-cdn.tripadvisor.com/media/photo-s/0b/1c/10/7e/marina-bay-view-from.jpg',
      'https://media-cdn.tripadvisor.com/media/photo-s/05/73/a8/05/marriott-cafe.jpg',
    ],
  }),
});
